import * as React from "react";
const SvgFiRrRewind = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-rewind_svg__a)">
      <path
        fill="#062147"
        d="M10.42 20.656a3.77 3.77 0 0 1-2.233-.735l-6.64-4.87a3.784 3.784 0 0 1 0-6.1l6.64-4.87A3.783 3.783 0 0 1 14.2 6.853l3.782-2.774A3.784 3.784 0 0 1 24 7.13v9.74a3.784 3.784 0 0 1-6.02 3.051l-3.78-2.774a3.79 3.79 0 0 1-3.777 3.51zm2.787-6.475a1 1 0 0 1 .592.194l5.363 3.933A1.784 1.784 0 0 0 22 16.87V7.13a1.785 1.785 0 0 0-2.839-1.438l-5.36 3.933a1 1 0 0 1-1.593-.806V7.13A1.784 1.784 0 0 0 9.37 5.692l-6.64 4.87a1.783 1.783 0 0 0 0 2.876l6.64 4.87a1.784 1.784 0 0 0 2.838-1.438v-1.689a1 1 0 0 1 1-1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-rewind_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRewind;
